import { render } from "./TemplateListTable.vue?vue&type=template&id=19a4e050&scoped=true&ts=true"
import script from "./TemplateListTable.vue?vue&type=script&lang=ts"
export * from "./TemplateListTable.vue?vue&type=script&lang=ts"

import "./TemplateListTable.vue?vue&type=style&index=0&id=19a4e050&scoped=true&lang=css"

import exportComponent from "C:\\repo\\ono\\ops-front-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19a4e050"]])

export default __exports__